import { render, staticRenderFns } from "./limitReachedCard.vue?vue&type=template&id=2914c9a1&"
import script from "./limitReachedCard.vue?vue&type=script&lang=js&"
export * from "./limitReachedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports